<!-- H5流程，发起页面 -->
<template lang="pug">
.startflow(v-loading="loading", element-loading-text="数据处理中...")
  .titleRow 基本信息
  component.approvalH5(
    :is="basicForm",
    ref="businessForm",
    :flowMessage="flowInfo",
    :formId="formId",
    :prjId="approvalPrjId",
    :flowDefinitionId="flowInfo.flowDefinitionId",
    @loadComplete="loadComplete",
    @change_showStartButtons="updateNodesEditor",
    @tableshow="tableshow",
    :uuid="uuid"
    flowModeStatus="initiate"
    flowLayoutType="H5"
    :key="comKey"
  )
  //- 兼容代码组件使用上传的展示文件列表，后期建议抛弃
  viewFileH5(ref="viewFileH5",:uuid="uuid", :flowKey="flowInfo.flowKey", v-if="!isLowCode")
  template(v-if="fileList.length")
    .uploaderTitle 流程模板附件
    defaultFileView(ref="defaultFileView",:uuid="uuid", :files="fileList", noDelete)
  .approval_steps
    .v_button(:class="{ tab_active: showType == 'user' }" @click="queryStep('user')") 审批节点
    .v_button(:class="{ tab_active: showType == 'img' }" @click="queryStep('img')") 查看流程图
  .flowShowImage(v-if="showType === 'img'")
    van-image(:src="flowImage" fit="contain" @click="imageShow = true")
    van-image-preview(v-model="imageShow" :images="[flowImage]" maxZoom="5")
  .flowShowNodes(v-if="showType === 'user'")
    flowNodesNew(ref="flowNodesNew", :uuid="uuid" source="h5")
</template>

<script>
import { getFlowImage } from "@/CommonDP/utils";
import flowNodesNew from "@/CommonDP/components/processComponents/flowNewConfig/flowNodesNew.vue";
import viewFileH5 from "@/CommonDP/components/processComponents/flowNewConfig/viewFileH5.vue";
import defaultFileView from "@/CommonDP/components/processComponents/flowNewConfig/defaultFileView.vue";
import { addApprovalMixins } from "@/CommonDP/components/processComponents/flowNew/mixins.js";

export default {
  components: { flowNodesNew, viewFileH5, defaultFileView },
  mixins: [addApprovalMixins],
  props: {
    // 唯一标识
    uuid: { type: String, default: "" }
  },
  data() {
    return {
      loading: true,
      basicForm: "",
      floderData: [], // 附件
      comKey: 0,
      approvalPrjId: "",
      showType: "", // user:处理人 ,img:流程图
      imageShow: false // 流程图放大预览
    };
  },
  computed: {
    // 低代码表单
    formId() {
      return this.flowInfo.formH5Code || this.flowInfo.formCode;
    },
    // 流程图
    flowImage() {
      return getFlowImage(this.flowInfo.flowImage.slice(7));
    },
    urlFiles() {
      return this.flowInfo.urlFiles || [];
    },
    fileList() {
      return this.floderData.map((e) => {
        return {
          ...e,
          fileId: e.fileId,
          fileName: e.fileName
        };
      });
    }
  },
  mounted() {
    this.addInit(true);
  },
  methods: {
    // 查询处理人设置
    async queryApproveNodes() {
      const validate = await this.startValidate();
      if (validate) {
        await this.getBasicData();
        await this.getNodesEditor();
        this.showType = "user";
      }
    },
    async queryStep(type) {
      if (type === "user") {
        await this.queryApproveNodes();
      } else {
        this.showType = type;
      }
    },
    // 查看流程图
    queryFlowImage() {
      this.showType = "img";
    }
  }
};
</script>

<style lang="scss" scoped>
.startflow {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .approvalH5 {
    padding: 5px;
    background-color: #fff;
  }
  .approval_steps{
    margin-top: 10px;
    background-color: #fff;
    width: 100%;
    height: 45px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    border-bottom: 1px solid #F5F5F5;
    .v_button{
      line-height: 30px;
    }
    .tab_active{
      color: #3873FE;
      border-bottom: 2px solid #3873FE;
    }
  }
  .flowShowImage {
    width: 100%;
    img {
      width: 100%;
      object-fit: contain;
    }
  }
  .flowShowNodes {
    width: 100%;
    background-color: #fff;
  }
}
::v-deep .el-row {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.titleRow {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  background-color: #fff;
  line-height: 40px;
  font-weight: bold;
  font-size: 15px;
  color: var(--key-color);
}
.uploaderTitle {
  height: 40px;
  padding: 0 10px;
  background: #fff;
  line-height: 45px;
  font-weight: bold;
  font-size: 15px;
}
</style>
